export const hints = [
  "奇数は何枚ある？",
  "偶数は何枚ある？（０も含む）",
  "０はどこ？",
  "１または２はどこ？（どちらかひとつ選ぶ）",
  "３または４はどこ？（どちらかひとつ選ぶ）",
  "５はどこ？",
  "６または７はどこ？（どちらかひとつ選ぶ）",
  "８または９はどこ？（どちらかひとつ選ぶ）",
  "赤の数字タイルは何枚ある？",
  "青の数字タイルは何枚ある？",
  "赤の数の合計は？",
  "青の数の合計は？",
  "小さいほうから３枚の数の合計は？",
  "中央の３枚の数の合計は？",
  "大きいほうから３枚の数の合計は？",
  "同じ数字タイルのペアは何組ある？",
  "同じ色がとなり合っている数字タイルはどこ？",
  "数が連続している数字タイルはどこ？",
  "［共有情報カード］中央の数字タイルは５以上？４以下？",
  "［共有情報カード］数字タイルすべての数の合計は？",
  "［共有情報カード］数字タイルの最大の数から最小の数を引いた数は？",
]

export const COLOR = {
  RED: "red",
  BLUE: "blue",
  YELLOW: "yellow"
}

export const cards = [
  {"index":0,"number":0, "color": COLOR.RED},
  {"index":1,"number":0, "color": COLOR.BLUE},
  {"index":2,"number":1, "color": COLOR.RED},
  {"index":3,"number":1, "color": COLOR.BLUE},
  {"index":4,"number":2, "color": COLOR.RED},
  {"index":5,"number":2, "color": COLOR.BLUE},
  {"index":6,"number":3, "color": COLOR.RED},
  {"index":7,"number":3, "color": COLOR.BLUE},
  {"index":8,"number":4, "color": COLOR.RED},
  {"index":9,"number":4, "color": COLOR.BLUE},
  {"index":10,"number":5, "color": COLOR.YELLOW},
  {"index":11,"number":5, "color": COLOR.YELLOW},
  {"index":12,"number":6, "color": COLOR.RED},
  {"index":13,"number":6, "color": COLOR.BLUE},
  {"index":14,"number":7, "color": COLOR.RED},
  {"index":15,"number":7, "color": COLOR.BLUE},
  {"index":16,"number":8, "color": COLOR.RED},
  {"index":17,"number":8, "color": COLOR.BLUE},
  {"index":18,"number":9, "color": COLOR.RED},
  {"index":19,"number":9, "color": COLOR.BLUE},
]

